export default __webpack_public_path__ + "static/media/xs-logo-aliment.07575f3d.svg";